var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.107 4.375h5.786V2.891c0-.492.43-.891.964-.891.535 0 .964.399.964.89v1.485h1.608C19.847 4.375 21 5.438 21 6.75v11.875C21 19.935 19.847 21 18.429 21H5.57C4.151 21 3 19.935 3 18.625V6.75c0-1.312 1.151-2.375 2.571-2.375H7.18V2.891c0-.492.43-.891.964-.891s.964.399.964.89zM4.93 18.625c0 .327.287.594.642.594H18.43c.353 0 .642-.267.642-.594v-9.5H4.93z"
  })));
};
export default SvgDate;